<template>
  <div
    id="home"
    v-loading="uploadLoading"
    element-loading-text="处理中"
    element-loading-background="rgba(255,255, 255, 0.5)"
  >
    <!-- <div class="topBar">
      <div class="prjTitle">
        网关远程配置中心
        <span>{{GatewayCode?`(网关编号：${GatewayCode})`:''}}</span>
      </div>
      <div class="prjTools">
        <el-dropdown
          @command="handleCommand"
          trigger="click"
        >
          <span class="el-dropdown-link">
            {{UserName}}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div> -->
    <div
      class="content"
    >
      <el-card class="box-card">
        <div
          slot="header"
          class="clearfix"
        >
          <span>基础信息</span>
        </div>
        <el-row>
          <el-col :span="4">
            <div class="grid-content bg-purple padTop">
              <div class="bold">SN&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;码 ：</div>
              <div>{{dataInfo.DeviceNo}}</div>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="grid-content bg-purple padTop">
              <div class="bold">在线状态：</div>
              <el-switch
                v-model="dataInfo.IsConnected"
                active-color="#409EFF"
                inactive-color="#DCDFE6"
                disabled
              >
              </el-switch>
            </div>
          </el-col>
          <el-col :span="7">
            <div class="grid-content bg-purple padTop">
              <div class="bold">最后联网时间：</div>
              <div>{{dataInfo.LastOnLineTime}}</div>
            </div>
          </el-col>
          <el-col :span="8">
            <el-button
              type="primary"
              size="mini"
              @click="GetBasicInfo"
            >刷新</el-button>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="4">
            <div class="grid-content bg-purple padTop">
              <div class="bold">设&nbsp;备&nbsp;名&nbsp;称&nbsp;：</div>
              <div>{{dataInfo.DeviceName}}</div>
            </div>
          </el-col>
          <el-col :span="20">
            <div class="grid-content bg-purple padTop">
              <div class="bold">联网方式：</div>
              <div>{{dataInfo.CommunicateMode == 1?'以太网':'4G'}}</div>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div class="grid-content bg-purple padTop">
              <div class="bold">MAC地址1：</div>
              <div>{{dataInfo.Mac1}}</div>
            </div>
          </el-col>
          <el-col :span="20">
            <div class="grid-content bg-purple padTop">
              <div class="bold">最新下传：</div>
              <div>{{dataInfo.TimeStringDown?
								dataInfo.TimeStringDown.substring(0,4)+'-'
								+dataInfo.TimeStringDown.substring(4,6)+'-'
								+dataInfo.TimeStringDown.substring(6,8)+' '
								+dataInfo.TimeStringDown.substring(8,10)+':'
								+dataInfo.TimeStringDown.substring(10,12)+':'
								+dataInfo.TimeStringDown.substring(12,14)
								:''}}</div>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div class="grid-content bg-purple padTop">
              <div class="bold">MAC地址2：</div>
              <div>{{dataInfo.Mac2}}</div>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="grid-content bg-purple padTop">
              <div class="bold">最新上传：</div>
              <div>{{dataInfo.TimeString?
								dataInfo.TimeString.substring(0,4)+'-'
								+dataInfo.TimeString.substring(4,6)+'-'
								+dataInfo.TimeString.substring(6,8)+' '
								+dataInfo.TimeString.substring(8,10)+':'
								+dataInfo.TimeString.substring(10,12)+':'
								+dataInfo.TimeString.substring(12,14)
								:''}}</div>
            </div>
          </el-col>
          <el-col :span="15">
            <div class="grid-content bg-purple padTop">
              <el-button
                type="primary"
                class="link"
                @click="sendTask(2)"
                size="mini"
              >
                上传配置
              </el-button>

              <el-button
                type="primary"
                class="link"
                @click="enterConfig"
                size="mini"
              >进入配置</el-button>
              <el-button
                type="primary"
                class="link"
                :disabled="Role===3"
                @click="upgradeConfig(3)"
                size="mini"
              >下传配置</el-button>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div class="grid-content bg-purple padTop">
              <div class="bold">程&nbsp;序&nbsp;版&nbsp;本&nbsp;：</div>
              <div>{{dataInfo.Ver}}</div>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="grid-content bg-purple padTop">
              <div class="bold">文件大小：</div>
              <div>{{dataInfo.FileSize}}KB</div>
              <el-button
                style="margin-left:20px"
                type="primary"
                class="link"
                :disabled="Role===3"
                @click="CompressDb"
                size="mini"
              >压缩配置</el-button>
              <!-- <i class="el-icon-question icon"></i> -->
            </div>
          </el-col>
          <el-col :span="15">
            <div class="grid-content bg-purple padTop flex">
              <div>
                <el-input
                  v-model="CopyDbNo"
                  placeholder="请输入设备SN码"
                  :disabled="Role===3?true:false"
                  size="mini"
                ></el-input>
              </div>
              <el-link
                style="margin-left:20px"
                type="primary"
                class="link"
                :disabled="Role===3"
                @click="CopyDb"
                size="mini"
              >导入配置</el-link>
            </div>
          </el-col>
        </el-row>

      </el-card>
    </div>
    <div class="main">
      <el-tabs v-model="activeName">
        <el-tab-pane
          label="网关信息"
          name="first"
        >
          <div class="tableCard">
            <div class="tableBtnBox">
               <div class="tableBtn">
                <el-button
                  type="primary"
                  size="mini"
                  @click="Remote"
                >远程重启</el-button>
              </div>
              <div class="tableBtn">
                <el-button
                  type="primary"
                  size="mini"
                  @click="readData"
                >读取</el-button>
                <el-button
                  size="mini"
                  @click="getDeviceInfo"
                >刷新</el-button>
              </div>
            </div>

            <el-table
              :data="gatewayData"
              height="380"
              border
              style="width: 100%"
              :header-cell-style="{background:'#2c86d1',color:'white',textAlign:'center'}"
              :cell-style="{textAlign:'center'}"
            >
              <el-table-column
                prop="Modular"
                label="模块名"
                minwidth="150"
                :show-overflow-tooltip="true"
              >
              </el-table-column>
              <el-table-column
                prop="Code"
                label="参数名"
                minwidth="150"
                :show-overflow-tooltip="true"
              >
              </el-table-column>
              <el-table-column
                prop="Value"
                label="参数值"
                minwidth="150"
                :show-overflow-tooltip="true"
              >
              </el-table-column>
              <el-table-column
                prop="LastUpdateTime"
                label="时间"
                minwidth="150"
                :show-overflow-tooltip="true"
              >
              </el-table-column>
            </el-table>

          </div>
        </el-tab-pane>
        <el-tab-pane
          label="历史记录"
          name="second"
        >
          <div class="mainBox">
            <el-form
              :inline="true"
              class="searchForm"
              size="mini"
            >
              <el-form-item
                label="操作时间"
                style="margin-bottom:0"
              >
                <el-date-picker
                  v-model="searchDate"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item
                label="任务类别"
                style="margin-bottom:0"
              >
                <el-select
                  v-model="searchForm"
                  placeholder="请选择任务类别"
                  style="width:100%"
                  filterable
                  clearable
                >
                  <el-option
                    v-for="item in searchType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item style="margin-bottom:0">
                <el-button
                  type="primary"
                  @click="hunt"
                >搜索</el-button>
              </el-form-item>
            </el-form>
            <el-table
              :data="huntData"
              border
              height="450"
              stripe
              style="width: 100%"
              :header-cell-style="{background:'#2c86d1',color:'white',textAlign:'center'}"
              :cell-style="{textAlign:'center'}"
            >
              <el-table-column
                prop="TasTypeName"
                label="任务类别"
                width="120"
              >
              </el-table-column>
              <el-table-column
                prop="DeviceNo"
                label="SN码"
                width="140"
              >
              </el-table-column>
              <el-table-column
                prop="DeviceName"
                label="设备名称"
                width="140"
              >
              </el-table-column>
              <el-table-column
                prop="Url"
                label="URL"
                minwidth="150"
                :show-overflow-tooltip="true"
              >
              </el-table-column>
              <el-table-column
                prop="UserCode"
                label="操作用户"
                width="100"
              >
              </el-table-column>
              <el-table-column
                prop="CreateTime"
                label="操作时间"
                width="160"
              >
              </el-table-column>
              <el-table-column
                prop="Status"
                label="状态"
                width="80"
              >
                <template slot-scope="scope">
                  <el-tag
                    v-if="scope.row.Status===0"
                    type="info"
                  >未处理</el-tag>
                  <el-tag
                    v-if="scope.row.Status===1"
                    type="success"
                  >成功</el-tag>
                  <el-tag
                    v-if="scope.row.Status===-1"
                    type="danger"
                  >失败</el-tag>
                  <el-tag
                    v-if="scope.row.Status===3"
                    type="danger"
                  >失败</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                prop="Result"
                label="结果信息"
                width="150"
              >
              </el-table-column>
              <el-table-column
                fixed="right"
                label="操作"
                width="120"
              >
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="RedoHistory(scope.row)"
                    :disabled="Role===3"
                    v-if="scope.row.Status != 3"
                  >恢复历史</el-button>
                </template>

              </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination
              class="listPage admin_page"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="huntTable.pageNum"
              :page-sizes="[10, 15, 45]"
              :page-size="huntTable.pageSize"
              layout="total,prev, pager, next, sizes, jumper"
              :total="huntTable.total"
              background
            >
            </el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="告警记录"
          name="third"
        >
          <div class="mainBox">
            <el-form size="mini" :inline="true">
              <el-form-item
                label="操作时间"
                style="margin-bottom:0"
              >
                <el-date-picker
                  v-model="warnDate"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item style="margin-bottom:0">
                <el-button
                  type="primary"
                  @click="Warning"
                >搜索</el-button>
              </el-form-item>
            </el-form>
          </div>
          <el-table
            :data="DeviceWarnData"
            border
            height="450"
            stripe
            style="width: 100%"
            :header-cell-style="{background:'#2c86d1',color:'white',textAlign:'center'}"
            :cell-style="{textAlign:'center'}"
          >

            <el-table-column
              prop="DeviceNo"
              label="SN码"
              minwidth="150"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              prop="DeviceName"
              label="设备名称"
              minwidth="150"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              prop="NowValue"
              label="参数"
              minwidth="150"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              prop="DeviceName"
              label="设备名称"
              minwidth="150"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              prop="Remark"
              label="具体说明"
              minwidth="150"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              prop="WarnCount"
              label="报警次数"
              minwidth="150"
              :show-overflow-tooltip="true"
            >
            </el-table-column>

            <el-table-column
              prop="CreateTime"
              label="生产时间"
              minwidth="150"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination
            class="listPage admin_page"
            @size-change="WarningSizeChange"
            @current-change="WarningCurrentChange"
            :current-page="WarningTable.pageNum"
            :page-sizes="[10, 15, 45]"
            :page-size="WarningTable.pageSize"
            layout="total,prev, pager, next, sizes, jumper"
            :total="WarningTable.total"
            background
          >
          </el-pagination>
        </el-tab-pane>
        <el-tab-pane
          label="版本升级"
          name="fourth"
        >
          <div class="mainBox">
            <div class="formBox">
              <el-form
                :inline="true"
                :model="upgradeForm"
                class="upgradeForm"
                size="mini"
              >
                <el-form-item label="应用类型:">
                  <el-cascader
                    v-model="upgradeForm.version"
                    :options="this.appList"
                    :props="{ expandTrigger: 'hover' }"
                    @change="handleChangeType"
                  >
                  </el-cascader>
                </el-form-item>
                <el-form-item label="URL:">
                  <el-input
                    v-model="upgradeForm.url"
                    disabled
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button
                    type="primary"
                    style="margin-left:10px"
                    :disabled="Role != 1 && Role !=2"
                    size="mini"
                    @click="DownApplication"
                  >下传应用</el-button>
                  <el-button
                    style="margin-left:10px"
                    @click="taskList"
                    size="mini"
                  >刷新</el-button>
                </el-form-item>

              </el-form>
            </div>
            <el-table
              :data="taskData"
              border
              height="440"
              stripe
              style="width: 100%"
              :header-cell-style="{background:'#2c86d1',color:'white',textAlign:'center'}"
              :cell-style="{textAlign:'center'}"
            >
              <el-table-column
                prop="TasTypeName"
                label="任务类别"
                width="120"
              >
              </el-table-column>
              <el-table-column
                prop="DeviceNo"
                label="SN码"
                minwidth="150"
                :show-overflow-tooltip="true"
              >
              </el-table-column>
              <el-table-column
                prop="DeviceName"
                label="设备名称"
                minwidth="150"
                :show-overflow-tooltip="true"
              >
              </el-table-column>
              <el-table-column
                prop="Url"
                label="URL"
                minwidth="150"
                :show-overflow-tooltip="true"
              >
              </el-table-column>
              <el-table-column
                prop="UserCode"
                label="操作用户"
                width="100"
              >
              </el-table-column>
              <el-table-column
                prop="CreateTime"
                label="操作时间"
                minwidth="150"
                :show-overflow-tooltip="true"
              >
              </el-table-column>
              <el-table-column
                prop="Status"
                label="状态"
                width="80"
              >
                <template slot-scope="scope">
                  <el-tag
                    v-if="scope.row.Status===0"
                    type="info"
                  >未处理</el-tag>
                  <el-tag
                    v-if="scope.row.Status===1"
                    type="success"
                  >成功</el-tag>
                  <el-tag
                    v-if="scope.row.Status===-1"
                    type="danger"
                  >失败</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                prop="Result"
                label="结果信息"
                minwidth="150"
                :show-overflow-tooltip="true"
              >
              </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination
              class="listPage admin_page"
              @size-change="VerSizeChange"
              @current-change="VerCurrentChange"
              :current-page="VerTable.pageNum"
              :page-sizes="[10, 15, 45]"
              :page-size="VerTable.pageSize"
              layout="total,prev, pager, next, sizes, jumper"
              :total="VerTable.total"
              background
            >
            </el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="数据库升级"
          name="five"
        >
          <div
            class="mainBox"
            style="height:405px;"
          >
            <el-form>
              <el-form-item>
                <el-button
                  type="primary"
                  class="SQLBtn"
                  @click="performSQL"
                  :disabled="Role===3"
                  size="mini"
                >执行脚本</el-button>
                <el-button
                  type="primary"
                  class="SQLBtn"
                  @click="CompressDb"
                  :disabled="Role===3"
                  size="mini"
                >数据库压缩</el-button>
                <el-button
                  type="primary"
                  class="SQLBtn"
                  @click="SQLDownload"
                  :disabled="Role===3"
                  size="mini"
                >
                  数据库下载
                </el-button>
                <el-upload
                  :accept="'.db'"
                  class="upload-demo"
                  action="action"
                  :http-request="uploadFile"
                  ref="upload"
                  :limit="fileLimit"
                  :on-exceed="handleExceed"
                  :before-upload="beforeUpload"
                  :file-list="fileList"
                  :show-file-list="false"
                  :disabled="Role===3"
                  size="mini"
                >
                  <el-button
                    :disabled="Role===3"
                    class="down"
                    size="mini"
                    type="primary"
                  >数据库上传</el-button>
                  <!-- <div slot="tip" class="el-upload__tip">只能上传db文件</div> -->
                </el-upload>

              </el-form-item>
              <el-form-item class="textarea">
                <div class="size">文件大小：{{dataInfo.FileSize}}KB</div>
                <el-input
                  type="textarea"
                  resize="none"
                  :autosize="{ minRows: 3, maxRows: 5}"
                  placeholder="请输入脚本"
                  v-model="sqlScript"
                >
                </el-input>
              </el-form-item>
            </el-form>

          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      value: true,
      activeName: "first",
      upgradeForm: {
        type: "",
        version: "",
        url: "",
      },
      TimeString: "",
      gatewayData: [],
      sqlScript: "",
      timer: "",
      appList: [],
      newArr: [],
      isRefresh: false,
      uploadLoading: false,
      dataInfo: {}, //基础信息
      huntData: [], //历史记录
      DeviceWarnData: [], //告警记录
      searchForm: "",
      searchType: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 3,
          label: "配置下传",
        },
        {
          value: 2,
          label: "配置上传",
        },
      ], //历史任务类型
      searchDate: [], //历史时间查询
      warnDate: [], //告警时间查询
      taskData: [], //版本升级列表数据
      CopyDbNo: "", //导入配置
      huntTable: {
        //历史分页
        // data: [],
        loading: false,
        pageSize: 15, //每页显示条数
        pageNum: 1, //当前页数
        total: 0, //总条数
      },
      WarningTable: {
        //告警分页'
        loading: false,
        pageSize: 15, //每页显示条数
        pageNum: 1, //当前页数
        total: 0, //总条数
      },
      VerTable: {
        //版本分页
        loading: false,
        pageSize: 15, //每页显示条数
        pageNum: 1, //当前页数
        total: 0, //总条数
      },
      baseURL: "", //路径
      fileList: [], //上传数据列表保存
      fileLimit: 3,

    };
  },

  mounted() {
    this.getDeviceInfo();
    this.getDeviceMsg();
    this.GetAppList();
    this.GetBasicInfo();
    this.DeviceWarnList();
    this.huntList();
    this.taskList(this.upgradeForm);
    /* 2.全局默认配置 */
    // 判断开发环境（一般用于本地代理）
    if (process.env.NODE_ENV === "development") {
      // 开发环境
      this.baseURL = glodApi.devUrl;
    } else {
      // 编译环境
      this.baseURL = glodApi.baseUrl;
    }

  },
  destroyed() {
    clearTimeout(this.timer);
  },
  computed: {
    ...mapGetters([
      "SessionId",
      "UserId",
      "DeviceID",
      "UserName",
      "Role",
      "GatewayCode",
    ]),
  },
  methods: {
    handleCommand(command) {
      if (command == "logout") {
        this.logout();
      }
    },
    async logout() {
      let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.User",
      };
      const res = await this.$api.axios_http(this.$gd.Logout, obj, "POST");
      if (res.ReturnCode == 0) {
        this.$message.success("退出成功");
        this.$store.commit("user/SET_USERINFO", {});
        localStorage.removeItem("userInfo");
        this.$router.push("/");
      } else {
        this.$message.error(res.Error);
      }
    },
    async enterConfig() {
      let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.User",
        Params: {
          DeviceID: this.DeviceID,
        },
      };
      const res = await this.$api.axios_http(
        this.$gd.GetConfigUrl,
        obj,
        "POST"
      );
      if (res.ReturnCode == 0) {
        window.open(res.Value, "_blank", "");
      } else {
        this.$message.error(res.Error);
      }
    },
    // 获取基本信息
    async GetBasicInfo() {
      let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.User",

        Params: {
          DeviceID: this.DeviceID,
        },
      };
      const res = await this.$api.axios_http(
        this.$gd.GetBasicInfo,
        obj,
        "POST"
      );
      if (res.ReturnCode == 0) {
        let Data = res.Value;
        if (Data.LastOnLineTime) {
          Data.LastOnLineTime = this.$moment(Data.LastOnLineTime).format(
            "YYYY-MM-DD HH:mm:ss"
          );
        }
        this.dataInfo = Data;
      }
    },
    //获取网关信息
    async getDeviceInfo() {
      let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.User",
        Params: {
          SearchList: [
            {
              CompareType: "Equal", //比较类型，参考附录
              PropertyName: "DeviceID", //参数名
              PropertyValue: this.DeviceID, //参数值
            },
          ],
        },
      };
      const res = await this.$api.axios_http(
        this.$gd.GetDeviceInfo,
        obj,
        "POST"
      );
      if (res.ReturnCode == 0) {
        //对时间进行格式化
        if (res.ReturnList) {
          res.ReturnList.forEach((item) => {
            if (item.LastUpdateTime) {
              item.LastUpdateTime = this.$moment(item.LastUpdateTime).format(
                "YYYY-MM-DD HH:mm:ss"
              );
            }
          });
        }
        this.gatewayData = res.ReturnList;
      } else {
        this.$message.error(res.Error);
      }
    },
    //确认升级配置
    upgradeConfig(type) {
      this.$messageBox
        .confirm("确认升级配置?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          this.sendTask(type);
        })
        .catch(() => {});
    },
    //发送任务(1:配置上传 2：配置下传 4应用down下传 5应用up下传 6应用ip下传)
    async sendTask(type, typeName, version,url) {

      this.uploadLoading = true;
      let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.User",
        Params: {
          DeviceID: this.DeviceID,
          TaskType: type,
          AppVersion: version ? version : "",
        },
      };
      if(type == 4){
        obj.Params.FileUrl = url
      }
      const res = await this.$api.axios_http(this.$gd.SendTask, obj, "POST");
      if (res.ReturnCode == 0) {
        let taskId = res.Value;
        let clock = 1; //计时，2秒执行一次，15时（30s）超时
        this.GetTask(taskId); //先执行一次
        this.timer = setInterval(() => {
          if (clock >= 30) {
            clearTimeout(this.timer);
            this.uploadLoading = false;
            this.$message({
              showClose: true,
              message: "获取结果超时，请重试",
              type: "error",
              duration: 0,
            });
          } else {
            clock++;
            this.GetTask(taskId);
          }
        }, 2000);
      } else {
        this.$message.error(res.Error);
        this.uploadLoading = false;
      }
    },
    // 远程重启
    async Remote(){
      this.$messageBox
        .confirm("确认要进行远程重启吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(async() => {
                this.uploadLoading = true;
      let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.User",
        Params: {
          DeviceID: this.DeviceID,
        },
      };
      const res = await this.$api.axios_http(this.$gd.Restart, obj, "POST");
      this.uploadLoading = false;
      if (res.ReturnCode == 0) {
        this.$message.success("操作成功");
        this.getList(this.searchForm);
      } else {
        this.$message.error(res.Error);
      }

        })
        .catch((err) => {
             this.uploadLoading = false;
        });



    },
    //读取设备列表
    async readData() {
      this.uploadLoading = true;
      let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.User",
        Params: {
          DeviceID: this.DeviceID,
        },
      };
      const res = await this.$api.axios_http(this.$gd.ReadData, obj, "POST");
      if (res.ReturnCode == 0) {
        let taskId = res.Value;
        let clock = 1; //计时，2秒执行一次，15时（30s）超时
        this.GetTask(taskId); //先执行一次
        this.timer = setInterval(() => {
          if (clock >= 30) {
            clearTimeout(this.timer);
            this.uploadLoading = false;
            this.$message({
              showClose: true,
              message: "获取结果超时，请重试",
              type: "error",
              duration: 0,
            });
          } else {
            clock++;
            this.GetTask(taskId);
          }
        }, 2000);
      } else {
        this.$message.error(res.Error);
        this.uploadLoading = false;
      }
    },
    //获取应用类型列表
    async GetAppList() {
      let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.User",
        Params: {},
      };
      const res = await this.$api.axios_http(this.$gd.GetAppList, obj, "POST");
      if (res.ReturnCode == 0) {
        let list = this.sortList(res.ReturnList);
        let newArr = [];
        for (let i = 0; i < list.length; i++) {
          newArr.push({
            value: list[i][0].AppType,
            label: list[i][0].AppType,
            children: [],
          });
          for (let j = 0; j < list[i].length; j++) {
            newArr[i].children.push({
              value: list[i][j].Verion,
              label: list[i][j].Verion,
            });
          }
        }
        this.appList = newArr;
      } else {
        this.$message.error(res.Error);
      }
    },
    //获取任务结果
    async GetTask(taskId) {
      let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.User",
        Params: {
          TaskID: taskId,
        },
      };
      const res = await this.$api.axios_http(this.$gd.GetTask, obj, "POST");
      if (res.ReturnCode == 0) {
        let status = res.Value.Status;
        if (status === -1) {
          clearTimeout(this.timer);
          this.uploadLoading = false;
          this.$message({
            showClose: true,
            message: "操作失败，请重试",
            type: "error",
            duration: 0,
          });
        }
        if (status === 1) {
          clearTimeout(this.timer);
          this.uploadLoading = false;
          this.$message({
            showClose: true,
            message: "操作成功",
            type: "success",
            duration: 0,
          });
          this.getDeviceMsg();
          this.getDeviceInfo();
        }
        if (status === 3) {
          clearTimeout(this.timer);
          this.uploadLoading = false;
          this.$message.error(res.Value.Result);
        }
      } else {
        this.$message.error(res.Error);
      }
    },
    sortList(sortData) {
      const groupBy = (array, f) => {
        let groups = {};
        array.forEach((o) => {
          let group = JSON.stringify(f(o));
          groups[group] = groups[group] || [];
          groups[group].push(o);
        });
        return Object.keys(groups).map((group) => {
          return groups[group];
        });
      };
      const sorted = groupBy(sortData, (item) => {
        return item.AppType; // 返回需要分组的对象
      });
      return sorted;
    },

    //获取设备信息(版本号)
    async getDeviceMsg(type) {
      if (type == 1) {
        this.isRefresh = true;
      }
      let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.User",
        Params: {
          DeviceID: this.DeviceID,
        },
      };
      const res = await this.$api.axios_http(
        this.$gd.GetDeviceMsg,
        obj,
        "POST"
      );
      if (res.ReturnCode == 0) {
        if (type == 1) {
          this.isRefresh = false;
          this.$message.success("刷新版本号成功");
        }
        let resData = JSON.parse(res.Value);
        this.TimeString = resData.TimeString;
      } else {
        this.$message.error(res.Error);
      }
    },
    //数据库升级
    async performSQL(type) {
      if (!this.sqlScript) {
        this.$message.error("内容不可为空");
        return;
      }
      let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.User",
        Params: {
          DeviceID: this.DeviceID,
          SqlScript: this.sqlScript,
        },
      };
      const res = await this.$api.axios_http(this.$gd.UpgradeDB, obj, "POST");
      if (res.ReturnCode == 0) {
        this.$message.success("数据库升级成功");
      } else {
        this.$message.error(res.Error);
      }
    },
    // 压缩配置
    async CompressDb() {
      let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.User",
        Params: {
          DeviceID: this.DeviceID,
        },
      };
      const res = await this.$api.axios_http(this.$gd.CompressDb, obj, "POST");
      if (res.ReturnCode == 0) {
        this.$message.success("操作成功");
        setTimeout(() => {
          this.GetBasicInfo();
        }, 1000);
      } else {
        this.$message.error(res.Error);
      }
    },
    //数据库下载
    SQLDownload() {
      this.$messageBox
        .confirm("确认下载数据库?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          //接口執行
          this.DownloadConfig();
        })
        .catch(() => {});
    },
    async DownloadConfig() {
      let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.User",
        Params: {
          DeviceID: this.DeviceID,
        },
      };
      const res = await this.$api.axios_http(
        this.$gd.DownloadConfig,
        obj,
        "POST"
      );
      if (res.ReturnCode == 0) {
        // 拿到返回的地址
        let Value = res.Value;
        let url = this.baseURL + "/" + Value;
        window.open(url);
        setTimeout(() => {
          this.$message.success("操作成功!");
        }, 2000);
      } else {
        this.$message.error(res.Error);
      }
    },
    // 数据库上传
    beforeUpload(file) {
      //校验上传文件类型
      var FileExt = file.name.replace(/.+\./, "");
      if (["db"].indexOf(FileExt.toLowerCase()) === -1) {
        this.$message({
          type: "warning",
          message: "请上传后缀名为db的附件！",
        });
        return false;
      }
    },
    //上传文件的事件
    uploadFile(item) {
      console.log("item", item);
      let file = item; //这是限制上传文件类型
      // 调用方法
      const isDB = item.file.type === "application/db";
      const isLt2M = item.file.size / 1024 / 1024 < 2;
      this.getBase64(file.file).then((result) => {
        var str = result;
        var baseValue = str.split(",")[1];
        console.log("传值哈哈", result);
        let obj = {
          SessionId: this.SessionId,
          UserId: this.UserId,
          ClientName: "Hoko.Iot.Web.System",
          Params: {
            DeviceID: this.DeviceID,
            FileData: baseValue, //传输内容 Base64 数据
          },
        };
        this.$api.axios_http(this.$gd.UploadConfig, obj, "POST").then((res) => {
          if (res.ReturnCode == 0) {
            this.$message.success("数据库上传成功");
          } else {
            this.$message.error("数据库上传失败");
          }
        });
      });
    },

    // 图片file转base64方法（file文件，回调函数）
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        let fileResult = "";
        reader.readAsDataURL(file);
        // 开始转
        reader.onload = () => {
          fileResult = reader.result;
        };
        // 转 失败
        reader.onerror = (error) => {
          reject(error);
        };
        // 转 结束
        reader.onloadend = () => {
          resolve(fileResult);
        };
      });
    },

    //超出文件个数的回调
    handleExceed() {
      this.$message({
        type: "warning",
        message: "超出最大上传文件数量的限制！",
      });
      return;
    },

    // 导入配置
    async CopyDb() {
      if (!this.CopyDbNo) {
        this.$message.error("内容不可为空!");
        return;
      }
      let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.User",
        Params: {
          DeviceID: this.DeviceID,
          DeviceNo: this.CopyDbNo,
        },
      };
      const res = await this.$api.axios_http(this.$gd.CopyDb, obj, "POST");
      if (res.ReturnCode == 0) {
        this.$message.success("操作成功");
        this.CopyDbNo = "";
        setTimeout(() => {
          this.GetBasicInfo();
        }, 1000);
      } else {
        this.$message.error(res.Error);
      }
    },
    //获取版本号
    DownApplication() {
      if (!this.upgradeForm.version) {
        this.$message.error("请选择应用类型");
        return false;
      }
      this.$messageBox
        .confirm("确认升级配置?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          this.sendTask(
            4,
            this.upgradeForm.version[0],
            this.upgradeForm.version[1],
            this.upgradeForm.url,
          );
        })
        .catch(() => {});
    },
    handleChangeType(value) {
      let arr = value;
      this.upgradeForm.url = `${arr[0]}/${arr[1]}/${arr[0]}`;
    },
    // 告警记录  DeviceWarn/GetList
    async DeviceWarnList(Stime, Etime) {
      let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.System",
        Params: {
          PageNumber: this.WarningTable.pageNum,
          PageSize: this.WarningTable.pageSize,
          SearchList: [
            {
              CompareType: "Equal",
              PropertyName: "DeviceID",
              PropertyValue: this.DeviceID,
            },
          ],
          sortList: [
            {
              SortDescend: true,
              SortProperty: "CreateTime",
            },
          ],
        },
      };
      if (Stime) {
        obj.Params.SearchList.push({
          CompareType: "GreaterOrEqual",
          PropertyName: "CreateTime",
          PropertyValue: Stime + " 00:00:00",
        });
      }
      if (Etime) {
        obj.Params.SearchList.push({
          CompareType: "LessOrEqual",
          PropertyName: "CreateTime",
          PropertyValue: Etime + " 23:59:59",
        });
      }
      const res = await this.$api.axios_http(this.$gd.DeviceWarn, obj, "POST");
      if (res.ReturnCode == 0) {
        if (res.ReturnList && res.ReturnList.length > 0) {
          res.ReturnList.forEach((item) => {
            if (item.CreateTime) {
              item.CreateTime = this.$moment(item.CreateTime).format(
                "YYYY-MM-DD HH:mm:ss"
              );
            }
          });
        }
        this.WarningTable.total = res.RecordCount;
        this.DeviceWarnData = res.ReturnList;
      }
    },
    Warning() {
      if (!this.warnDate) {
        this.warnDate = [];
      }
      this.DeviceWarnList(...this.warnDate);
    },
    //告警翻页事件
    WarningSizeChange(val) {
      this.WarningTable.pageSize = val;
      this.DeviceWarnList(...this.warnDate);
    },
    //告警翻页事件
    WarningCurrentChange(val) {
      this.WarningTable.pageNum = val;
      this.DeviceWarnList(...this.warnDate);
    },
    // 历史记录
    async huntList(searchForm, Stime, Etime) {
      let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.System",
        Params: {
          PageNumber: this.huntTable.pageNum,
          PageSize: this.huntTable.pageSize,
          SearchList: [
            {
              CompareType: "GreaterThan",
              PropertyName: "TaskType",
              PropertyValue: 1,
            },
            {
              CompareType: "LessThan",
              PropertyName: "TaskType",
              PropertyValue: 4,
            },
            {
              CompareType: "Equal",
              PropertyName: "DeviceID",
              PropertyValue: this.DeviceID,
            },
          ],
          SortList: [
            {
              SortDescend: true,
              SortProperty: "CreateTime",
            },
          ],
        },
      };
      if (searchForm || searchForm === 0) {
        obj.Params.SearchList.push({
          CompareType: "Equal",
          PropertyName: "TaskType",
          PropertyValue: searchForm,
        });
      }

      if (Stime) {
        obj.Params.SearchList.push({
          CompareType: "GreaterOrEqual",
          PropertyName: "CreateTime",
          PropertyValue: Stime + " 00:00:00",
        });
      }
      if (Etime) {
        obj.Params.SearchList.push({
          CompareType: "LessOrEqual",
          PropertyName: "CreateTime",
          PropertyValue: Etime + " 23:59:59",
        });
      }
      const res = await this.$api.axios_http(
        this.$gd.admin.task.getList,
        obj,
        "POST"
      );
      if (res.ReturnCode == 0) {
        if (res.ReturnList && res.ReturnList.length > 0) {
          res.ReturnList.forEach((item) => {
            if (item.CreateTime) {
              item.CreateTime = this.$moment(item.CreateTime).format(
                "YYYY-MM-DD HH:mm:ss"
              );
            }
          });
        }
        this.huntTable.total = res.RecordCount;
        this.huntData = res.ReturnList;
      }
    },
    // 历史记录搜索
    hunt() {
      if (!this.searchDate) {
        this.searchDate = [];
      }
      this.huntList(this.searchForm, ...this.searchDate);
    },
    //历史翻页事件
    handleSizeChange(val) {
      this.huntTable.pageSize = val;
      this.huntList(this.searchForm, ...this.searchDate);
    },
    //历史翻页事件
    handleCurrentChange(val) {
      this.huntTable.pageNum = val;
      this.huntList(this.searchForm, ...this.searchDate);
    },

    async RedoHistory(data) {
      console.log(data);
      let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.System",
        Params: {
          TaskID: data.TaskID,
        },
      };
      const res = await this.$api.axios_http(this.$gd.Resume, obj, "POST");
      if (res.ReturnCode == 0) {
        this.$message.success("操作成功");
        this.huntList(this.upgradeForm);
      } else {
        this.$message.error(res.Error);
      }
    },
    //获取版本升级列表数据
    async taskList(upgradeForm) {
      let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.System",
        Params: {
          PageNumber: this.VerTable.pageNum,
          PageSize: this.VerTable.pageSize,
          SearchList: [
            {
              CompareType: "GreaterThan",
              PropertyName: "TaskType",
              PropertyValue: 3,
            },
            {
              CompareType: "LessThan",
              PropertyName: "TaskType",
              PropertyValue: 7,
            },
            {
              CompareType: "Equal",
              PropertyName: "DeviceID",
              PropertyValue: this.DeviceID,
            },
          ],
          SortList: [
            {
              SortDescend: true,
              SortProperty: "CreateTime",
            },
          ],
        },
      };
      const res = await this.$api.axios_http(
        this.$gd.admin.task.getList,
        obj,
        "POST"
      );
      if (res.ReturnCode == 0) {
        if (res.ReturnList && res.ReturnList.length > 0) {
          res.ReturnList.forEach((item) => {
            if (item.CreateTime) {
              item.CreateTime = this.$moment(item.CreateTime).format(
                "YYYY-MM-DD HH:mm:ss"
              );
            }
          });
        }
        this.VerTable.total = res.RecordCount;
        this.taskData = res.ReturnList;
        // console.log("任务列表", this.taskData);
      }
    },
    //历史翻页事件
    VerSizeChange(val) {
      this.VerTable.pageSize = val;
      this.taskList();
    },
    //历史翻页事件
    VerCurrentChange(val) {
      this.VerTable.pageNum = val;
      this.taskList();
    },
  },
};
</script>
<style lang="scss" scoped>
#home {
  // height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-width: 1300px;
  // padding: 60px;
  // box-sizing: border-box;
}
.topBar {
  height: 80px;
  line-height: 80px;
  background: #2c86d1;
  color: white;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 20px;
}

.content {
  // display: flex;
  // flex: 1;
  width: 100%;
  height: 28%;
  box-sizing: border-box;
  padding: 10px;
  overflow: auto;
  font-size: 14px;
  /deep/.el-card__body,
  /deep/.el-main {
    padding: 15px;
  }
  /deep/.el-card__header {
    padding: 15px;
    font-size: 16px;
    color: #409eff;
    background: #f5f7fa;
  }
}

.topBar {
  .prjTitle {
    font-size: 24px;
    span {
      font-size: 18px;
      margin-left: 5px;
    }
  }
  .el-dropdown-link {
    cursor: pointer;
    color: white;
  }
}
.padTop {
  display: flex;
  padding-bottom: 10px;
  align-items: center;
  .bold {
    font-size: 14px;
    font-weight: bold;
  }
  .link {
    margin-right: 20px;
  }
  .icon {
    font-size: 16px;
    color: #606266;
  }
}

.main {
  height: 580px;
  font-size: 14px;
  background: #ffffff;
  margin: 0px 10px 10px;
  padding: 0 10px 10px;
  border-radius: 4px;
  .tableBtnBox{
    display: flex;
    justify-content: space-between;
    .tableBtn {
      padding:0px 10px 10px;
    }
  }

}
.mainBox {
  // padding-bottom: 30px;
  .el-form-item {
    margin-bottom: 5px;
  }
  .inp {
    width: 46%;
  }
  .SQLBtn {
    margin-top: 15px;
  }
  .textarea {
    width: 75%;
    .size {
      text-align: right;
    }
  }
}
.upload-demo {
  display: inline-block;
  justify-content: center;
  padding-left: 10px;
  .down {
    // width: 110px;
    // height: 39.8px;
  }
}
</style>
<style lang="scss">
.dbBox {
  .el-textarea {
    height: 100%;
    margin-right: 10px;
    .el-textarea__inner {
      height: 100%;
    }
  }
}
</style>
